import { webappClient } from "../clients";
import { validatePayload, validateResponse } from "../validation";
import { getUtmParams } from "../../../tracking/getUtmParams";
import { SUPPORTED_POTENTIAL_REGULATIONS } from "../../settings/constants";
import { format } from "date-fns";
import { z } from "zod";
import { ItineraryFlights } from "../../modules/types/intake-funnel";

const potentialRegulationResponseSchema = z.object({
  potential_regulation: z.enum(SUPPORTED_POTENTIAL_REGULATIONS).nullable(),
});

const potentialRegulationRequestSchema = z
  .array(
    z.object({
      disrupted: z.boolean(),
      flight_number: z.string(),
      airline_identifier: z.string(),
      local_departure_date: z.string(),
      arrival_airport_code: z.string(),
      departure_airport_code: z.string(),
      airline_code: z.string().nullable(),
    }),
  )
  .refine(
    (flights) => flights.some((flight) => flight.disrupted),
    "At least one flight should be disrupted",
  );

export async function fetchPotentialRegulation(itineraryFlights: Readonly<ItineraryFlights>) {
  const validatedPayload = validatePayload({
    data: itineraryFlights.map((itineraryFlight) => ({
      disrupted: itineraryFlight.disrupted,
      flight_number: itineraryFlight.flightNumber,
      airline_identifier: itineraryFlight.airline?.uniqueIdentifier,
      local_departure_date:
        itineraryFlight.flightDate && format(itineraryFlight.flightDate, "dd-MM-yyyy"),
      arrival_airport_code: itineraryFlight.arrivalAirport?.iata,
      departure_airport_code: itineraryFlight.departureAirport?.iata,
      airline_code: itineraryFlight.airline?.iata,
    })),
    schema: potentialRegulationRequestSchema,
    tag: "Potential regulation request payload",
  });

  const data = await webappClient
    .post("api/eligibility/potential_regulations", {
      headers: { "X-Utms": JSON.stringify(getUtmParams()) },
      json: {
        flights: validatedPayload,
      },
    })
    .json();

  const result = validateResponse({
    data,
    schema: potentialRegulationResponseSchema,
    tag: "Potential regulation API response",
  });

  return result.potential_regulation;
}
